var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LOL404"},[_c('h1',[_vm._v("le 404")]),_c('div',[_vm._v("hey man cant find what ur looking for, sorry lol")])])}]

export { render, staticRenderFns }